import {
  FEATURES,
  featureFlagsReady,
  hasFeature,
} from '@/features/feature-flags';
import { GOOGLE_SIGNUP_VISITOR_ID_KEY } from '@/features/login/google-signup-consent-config';
import { userStore } from '@/stores/user.store';
import { AppCapability, isCapable } from '@/utils/capabilities';

const SESSION_COMPLETED_KEY = 'web-onboarding-completed-session';

/** Cleared on logout so `web-onboarding-always` shows the flow again on next login. */
export function clearWebOnboardingSessionCompletion(): void {
  sessionStorage.removeItem(SESSION_COMPLETED_KEY);
  sessionStorage.removeItem(GOOGLE_SIGNUP_VISITOR_ID_KEY);
}

/** Set when the user finishes onboarding so route guards allow entry into the app. */
export function markWebOnboardingCompletedThisSession(): void {
  sessionStorage.setItem(SESSION_COMPLETED_KEY, '1');
}

function hasWebOnboardingCompletedThisSession(): boolean {
  return sessionStorage.getItem(SESSION_COMPLETED_KEY) === '1';
}

/**
 * PostHog `web-onboarding` enables the feature; `web-onboarding-always` forces it on
 * every login (for testing). After finishing in a session, guards skip until logout.
 */
export async function shouldShowWebOnboarding(): Promise<boolean> {
  if (!isCapable(AppCapability.WebOnboarding)) return false;
  await featureFlagsReady();
  if (!hasFeature(FEATURES.WEB_ONBOARDING)) return false;
  if (hasWebOnboardingCompletedThisSession()) return false;
  if (hasFeature(FEATURES.WEB_ONBOARDING_ALWAYS)) return true;
  return userStore.needsWebOnboarding;
}
